export enum WebsocketMsgType {
  Zone = 'Zone',
  Site = 'Site',
  Alarm = 'Alarm',
}
